import { create } from 'zustand';

import {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  setRefreshToken,
  clearTokens as clearCookieTokens,
} from 'utils/cookies';

interface TokenState {
  accessToken: string;
  refreshToken: string;
  setAccessToken: (token: string, expiresIn: number) => void;
  setRefreshToken: (token: string, expiresIn: number) => void;
  clearTokens: () => void;
}

const useTokenStore = create<TokenState>()((set) => ({
  accessToken: getAccessToken() || '',
  refreshToken: getRefreshToken() || '',
  setAccessToken: (token: string, expiresIn: number) => {
    setAccessToken(token, expiresIn);
    set({ accessToken: token });
  },
  setRefreshToken: (token: string, expiresIn: number) => {
    setRefreshToken(token, expiresIn);
    set({ refreshToken: token });
  },
  clearTokens: () => {
    clearCookieTokens();
    set({ accessToken: '', refreshToken: '' });
  },
}));

export { useTokenStore };
